import {
  project1Laptop,
  project1Mobile,
  project2Laptop,
  project2Mobile,
  project3Laptop,
  project3Mobile,
  project4Laptop,
  project4Mobile,
  project5Laptop,
  project5Mobile,
  project6Laptop,
  project6Mobile,
  project7Laptop,
  project7Mobile,
  project8Laptop
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: project7Laptop,
    transitionImage: project7Mobile,
    title: "Disney Hoststar Blog",
    codeLink: "hhttps://github.com/Rusta007/Disney_Hotstar",
    liveLink: "https://teal-mooncake-57faee.netlify.app/",
  },
  {
    id: 2,
    image: project6Mobile,
    transitionImage: project8Laptop,
    title: "PrepBytes Dashboard Website",
    codeLink: "https://github.com/Rusta007/Prep_Dashboard",
    liveLink: "https://63d9e0ff6d13d433af436769--frabjous-dieffenbachia-764aa3.netlify.app/",
  },
  {
    id: 3,
    image: project3Laptop,
    transitionImage: project1Mobile,
    title: "React Blog App",
    codeLink: "https://github.com/Rusta007/React-BlogApp",
    liveLink: "https://6253d945d7935424b9b8a445--cool-halva-144d79.netlify.app/",
  },
  {
    id: 4,
    image: project2Laptop,
    transitionImage: project2Mobile,
    title: "Digital Clock",
    codeLink: "https://github.com/Rusta007/Digital-Clock",
    liveLink: "https://rusta007.github.io/Digital-Clock/",
  },
  {
    id: 5,
    image: project5Laptop,
    transitionImage: project5Mobile,
    title: "Gym Fitness Website",
    codeLink: "https://github.com/monciego/intrepide",
    liveLink: "https://intrepide.netlify.app/",
  },
  {
    id: 6,
    image: project6Laptop,
    transitionImage: project6Mobile,
    title: "Space Tourism",
    codeLink: "https://github.com/monciego/space-tourism",
    liveLink: "https://spacetourism-monciego.netlify.app/",
  },
];
